module.exports = __webpack_public_path__ + "static/media/color_blind_image_7.11f69c42.jpg";